import TabPage from '@/components/TabPage';

export default function Radar() {
  return <TabPage chartFullKeys={['customer_rank', 'person_rank']} />;
}
